import { render, staticRenderFns } from "./act-info-dialog.vue?vue&type=template&id=b0fdfaa0&scoped=true&"
import script from "./act-info-dialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./act-info-dialog.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./act-info-dialog.vue?vue&type=style&index=0&id=b0fdfaa0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fdfaa0",
  null
  
)

export default component.exports